import createIcon from './hocs/createIcon';
var EmailIcon = createIcon({
    color: '#7f7f7f',
    networkName: 'email',
    path: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
});
export default EmailIcon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/EmailIcon.js
// module id = 613
// module chunks = 0